<template>
  <div class="user-detail">
    <!-- 基础信息部分 -->
    <headline title="基本信息" class="headline"/>
    <el-divider class="base-divider"/>
    <el-table class="zwx-table zwx-table-detail" style="width: 100%;" row-key="key" :data="dataList"
              :show-header="false" border :stripe="false">
      <el-table-column prop="key" width="86" header-align="right" align="right"/>
      <el-table-column prop="value" header-align="left" align="left"/>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'UserDetail',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      dataList: [],
    }
  },
  created() {
  },
  mounted() {
    this.detail()
  },
  computed: {},
  methods: {
    detail() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getUserInfo-1', data, true, true, this.detailSuccess, this.error)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.dataList.push({key: '地区：', value: data.userInfo.fkByUnitId.fkByZoneId.fullName})
        this.dataList.push({key: '机构名称：', value: data.userInfo.fkByUnitId.unitName})
        this.dataList.push({key: '用户账号：', value: data.userInfo.userNo})
        this.dataList.push({key: '用户姓名：', value: data.userInfo.userName})
        this.dataList.push({key: '组织架构：', value: this.organListValue(data.userInfo.organList)})
        this.dataList.push({key: '授权码：', value: data.userInfo.authCode})
        this.dataList.push({key: '曾用名：', value: data.userInfo.usedName})
        this.dataList.push({
          key: '性别：',
          value: data.userInfo.userSexSimpleCode ? data.userInfo.userSexSimpleCode.codeName : ''
        })
        this.dataList.push({key: '手机号码：', value: this.$zwxSm.sm4JsDecrypt(data.userInfo.mobileTel)})
        this.dataList.push({key: '身份证号：', value: this.$zwxSm.sm4JsDecrypt(data.userInfo.idc)})
        this.dataList.push({
          key: '民族：',
          value: data.userInfo.userNationSimpleCode ? data.userInfo.userNationSimpleCode.codeName : ''
        })
        this.dataList.push({key: '出生日期：', value: this.$system.formatDate(data.userInfo.birthday, 'YYYY-MM-DD')})
        this.dataList.push({
          key: '学历：',
          value: data.userInfo.educationSimpleCode ? data.userInfo.educationSimpleCode.codeName : ''
        })
        this.dataList.push({
          key: '学位：',
          value: data.userInfo.degreeSimpleCode ? data.userInfo.degreeSimpleCode.codeName : ''
        })
        this.dataList.push({
          key: '婚姻状况：',
          value: data.userInfo.maritalStatusSimpleCode ? data.userInfo.maritalStatusSimpleCode.codeName : ''
        })
        this.dataList.push({
          key: '政治面貌：',
          value: data.userInfo.politicalLandscapeSimpleCode ? data.userInfo.politicalLandscapeSimpleCode.codeName : ''
        })
        this.dataList.push({
          key: '宗教信仰：',
          value: data.userInfo.religionSimpleCode ? data.userInfo.religionSimpleCode.codeName : ''
        })
        this.dataList.push({key: '职位：', value: data.userInfo.position})
        this.dataList.push({key: '职称：', value: data.userInfo.jobTitle})
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    organListValue(organList) {
      if (organList === undefined || organList === null || organList.length === 0) return ''
      let value = ''
      for (let i = 0, length = organList.length; i < length; i++) {
        if (i > 0) value += '、'
        value += organList[i].organName
      }
      return value
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
